import { Team, type Board } from '@apps/www/src/__generated__/graphql';
import SVA from '@pkgs/shared-client/components/SVA';
import SVButton, { SVButtonSIZES, SVButtonUSES } from '@pkgs/shared-client/components/SVButton';
import SVLink from '@pkgs/shared-client/components/SVLink';
import SVModal from '@pkgs/shared-client/components/SVModal';
import InviteType from '@pkgs/shared/enums/InviteType';

const _SVExtraSeatsModal = (props: {
	type: typeof InviteType.TEAM | typeof InviteType.BOARD;
	resourceID: Board['_id'] | Team['_id'];
}) => {
	return (
		<>
			<div className="type-small-title text-primary text-left font-medium">
				Add extra seats
			</div>
			<div className="mt-1 flex flex-col space-y-5">
				<p className="text-[12px] font-medium text-gray-500">
					Your team has reached its seat limit.
				</p>
				<p className="text-[12px] font-medium text-gray-500">
					We'd love to help you bring more people in.
				</p>
				<p className="text-[12px] font-medium text-gray-500">
					Reach out to{' '}
					<SVA href="mailto:hey@savee.com" className="text-primary">
						hey@savee.com
					</SVA>{' '}
					and we'll set you up with extra seats so your whole team can keep exploring
					inspiration together.
				</p>
			</div>
			<div className="flex justify-center">
				<SVButton
					className=" mt-5 px-6 py-3 text-[12px]"
					to="/contact/"
					Component={SVLink}
					use={SVButtonUSES.PRIMARY}
					size={SVButtonSIZES.TINY}
				>
					Contact us
				</SVButton>
			</div>
		</>
	);
};

const SVExtraSeatsModal = SVModal.create(_SVExtraSeatsModal, {
	className: 'w-[244px] -sm:w-full',
});

export default SVExtraSeatsModal;
